import { Suspense, useRef } from 'react';
import { Outlet } from 'react-router-dom';
// import { Box } from './SharedLayout.styled';
import { HeaderComp } from 'components/Header/Header';
import { FooterComp } from 'components/Footer/Footer';

export const SharedLayout = () => {
  const footerRef = useRef(null);
  return (
    <>
      <Suspense fallback={'Loading...'}>
        <HeaderComp footerRef={footerRef}/>

        <main>
          <Outlet />
        </main>
      </Suspense>
      <FooterComp ref={footerRef}/>
    </>
  );
};
